<template>
  <v-combobox
    label="School / Institution"
    v-model="selected"
    @input="handleInput"
    :disabled="disabled"
    :hint="hint"
    :items="institutions"
    :loading="loading"
    :placeholder="institutionName"
    :required="required"
    :rules="rules || []"
    :search-input.sync="institutionName"
    clearable
    hide-no-data
    menu-props="closeOnClick"
    no-filter
    return-object
  >
    <template slot="item" slot-scope="{ item: institution }">
      <v-list-tile-avatar>
        <img :src="institution.logo || '/img/missing/logos/institutions/original.png'" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ institution.name }}</v-list-tile-title>
        <v-list-tile-sub-title v-if="institution.acronym">
          {{ institution.acronym }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
    <template slot="selection" slot-scope="{ item: institution }">
      <v-chip v-if="institution.name">
        <v-avatar v-if="institution.logo">
          <img :src="institution.logo" />
        </v-avatar>
        {{ institution.name }}
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
// Helpers
import _ from 'lodash'
import { mapGetters } from 'vuex'

// Vue Component
export default {
  props: {
    value: [Object, Number],
    rules: Array,
    required: Boolean,
    disabled: Boolean,
    hint: { type: String, default: () => 'Search Institutions' },
  },

  created() {
    if (_.get(this.value, 'id')) {
      Vue.$http.get(`admin/institutions/${this.value.id}`).then(response => {
        this.institutions = [response.data]
        this.selected = response.data
      })
    } else if (Number.isInteger(this.value)) {
      Vue.$http.get(`admin/institutions/${this.value}`).then(response => {
        this.institutions = [response.data]
        this.selected = response.data
      })
    } else if (_.get(this.value, 'name')) {
        this.institutionName = this.value.name
        this.selected = this.value
        this.search()
    }
  },

  data() {
    return {
      selected: null,
      loading: false,
      institutionName: '',
      institutions: [],
    }
  },

  watch: {
    institutionName: _.debounce(function(institution) {
      // institution is null on initial load
      if (institution && institution.length > 2) {
        this.search()
      } else {
        this.institutions = []
      }
    }, 500),
  },

  methods: {
    handleInput(institution) {
      if (institution) {
        if (institution.name) {
          this.selected = institution
          this.$emit('input', institution)
        } else {
          this.selected = { id: null, name: institution }
          this.$emit('input', { id: null, name: institution })
        }
      } else {
        this.selected = null
        this.$emit('input', {})
      }
    },

    search() {
      // Update options
      this.loading = true
      Vue.$http
        .get(`search/institutions?search=${this.institutionName}`)
        .then(response => {
          this.institutions = response.data
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>
